import { styled } from '@mui/material/styles';
import { Drawer, ListItemButton, Divider } from '@mui/material';

const drawerWidth = 200;

// Sidebar drawer component
export const SidebarDrawer = styled(Drawer)(() => ({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
  },
}));

// Toolbar area at the top of the sidebar
export const SidebarToolbar = styled('div')(({ theme }) => ({
  ...theme.mixins.toolbar,
  textAlign: "center",
}));

// Logo image inside the toolbar
export const SidebarLogo = styled('img')(() => ({
  maxWidth: "80%",
}));

// Active navigation item styling
export const ActiveNavItem = styled(ListItemButton)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  "&:hover": {
    background: theme.palette.primary.dark,
  },
}));

// Divider with margin
export const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(1, 0),
})); 